import React from 'react'
import styled from 'styled-components'
import ReactTable from 'react-table'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import 'react-table/react-table.css'
import './TableStyles.scss'

import { Button } from './'

const DroppableContainer = styled.div`
  margin-bottom: 40px;
`

const PaginationButton = styled(Button)`
  width: 40px !important;
  border: none;
`

const NextComponent = ({disabled, onClick}) => (
  <PaginationButton onClick={onClick} disabled={disabled}>{">"}</PaginationButton>
)

const PreviousComponent = ({disabled, onClick}) => (
  <PaginationButton onClick={onClick} disabled={disabled}>{"<"}</PaginationButton>
)

const NoDataComponent = styled.div`
  padding: 20px;
  margin: auto auto;
`

const DefaultTr = styled.div.attrs(props => ({
  className: `rt-tr ${props.className}`,
  role: 'row'
}))``

const TrDraggableComponent = (props) => {
  if (props.rowInfo) {
    return (
      <Draggable key={`item${props.rowInfo.index}`} draggableId={`item${props.rowInfo.index}`} index={props.rowInfo.index}>
      {(provided, snapshot) => (
        <DefaultTr
          {...props}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {props.children}
        </DefaultTr>
      )}
      </Draggable>
    )
  }
  return <DefaultTr {...props} />
}

const TbodyDroppableComponent = (props) => {
  return (
    <Droppable droppableId="droppable">
      {(provided, snapshot) => (
        <DroppableContainer
          {...provided.droppableProps}
          ref={provided.innerRef}
          {...props}
        >
          {props.children}
          {provided.placeholder}
        </DroppableContainer>
      )}
    </Droppable>
  )
}

const DefaultTable = (props) => {
  return (
  <ReactTable 
    resizable={false} 
    showPagination={false} 
    showPageSizeOptions={false}
    minRows={0} 
    pageText={"Página"}
    pageSize={props.data.length}
    ofText={"de"}
    NextComponent={NextComponent}
    PreviousComponent={PreviousComponent}
    NoDataComponent={NoDataComponent}
    {...props} 
  />
)}

export const Table = ({draggable, onDragEnd, ...props}) => {
  if (draggable) {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <DefaultTable
          TrComponent={TrDraggableComponent}
          TbodyComponent={TbodyDroppableComponent}
          getTrProps={(state, rowInfo, column) => {
            return { rowInfo };
          }}
          {...props}
        />
      </DragDropContext>
    )
  } else {
    return <DefaultTable {...props} />
  }
}
